module.exports = __webpack_public_path__ + "static/media/image-placeholder.294de88d.jpg";